import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import CategoryTable from '../components/CategoryTable';

const Category = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [categotyImages, setCategoryImages] = useState([]);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.CATEGORY}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_CATEGORY,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsCategoryModalOpen(true);
              setCategoryImages();
            }}
          >
            Add New Category
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_CATEGORY,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsCategoryModalOpen(true);
              setCategoryImages([]);
            }}
          >
            Add New Category
          </Button>
        )}
      </Portal>
      <Card className="full-height-without-nav">
        <CategoryTable
          isCategoryModalOpen={isCategoryModalOpen}
          setIsCategoryModalOpen={setIsCategoryModalOpen}
          setCategoryImages={setCategoryImages}
          categotyImages={categotyImages}
        />
      </Card>
    </>
  );
};

export default Category;
